export const confirmationModalName = 'confirmationModal';
